import React, { useEffect } from "react";
import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.min.css";

const VideoCard = () => {
    useEffect(() => {
        const lightbox = GLightbox({
            selector: "[data-glightbox]",
            touchNavigation: true,
            loop: true,
        });

        return () => {
            lightbox.destroy();
        };
    }, []);

    return (
        <div className="card card-body overflow-hidden p-0">
            <img src="/15.jpg" className="card-img" alt="video-img" />
            <div className="bg-overlay bg-dark opacity-3"></div>
            <div className="card-img-overlay d-flex p-3">
                <div className="m-auto">
                    <a
                        href="https://www.youtube.com/embed/tXHviS-4ygo"
                        className="btn btn-lg btn-white btn-round stretched-link mb-0"
                        data-glightbox
                        data-gallery="course-video"
                    >
                        <i className="fas fa-play"></i>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default VideoCard;
